<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      v-if="dataType != 'itemTag'"
      prop="itemId"
      :label="firstColumnLabel"
      width="180"
      align="center"
    />
    <el-table-column
      v-if="dataType == 'itemTag'"
      prop="classifyName"
      label="标签分类"
      width="180"
      align="center"
    />
    <el-table-column
      prop="itemName"
      :label="secondColumnLabel"
      width="180"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.itemName" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="buyCount"
      label="购买人数"
      width="120"
      align="center"
    />
    <el-table-column
      prop="buyOrderCount"
      label="购买单量"
      width="120"
      align="center"
    />
    <el-table-column
      prop="buyItemCount"
      label="购买件数"
      width="120"
      align="center"
    />
    <el-table-column
      prop="buyAmount"
      label="购买金额"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="rank"
      :label="prevReportView == 0 ? '关联排名' : '关联率排名'"
      width="100"
      align="center"
    />
    <el-table-column
      v-if="dataType != 'itemTag'"
      prop="relateItemId"
      :label="thirdColumnLabel"
      min-width="180"
      align="center"
    />
    <el-table-column
      v-if="dataType == 'itemTag'"
      prop="relateClassifyName"
      label="关联标签分类"
      min-width="180"
      align="center"
    />
    <el-table-column
      prop="relateItemName"
      :label="fourthColumnLabel"
      min-width="120"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.relateItemName" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="relateCount"
      label="关联人数"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="relateOrderCount"
      label="关联订单数"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="relateItemCount"
      label="关联件数"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="relateAmount"
      label="关联金额"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="relateRateStr"
      label="关联率"
      min-width="120"
      align="center"
    />
  </el-table>
</template>

<script>
import mixins from "../../../mixins/index.js";
import Empty from "../../../components/empty.vue";
export default {
  mixins: [mixins],
  components: {
    Empty,
    textOverflowTooltip: () =>
      import(
        "@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"
      ),
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
		reportParams: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    countTable() {
      const tableList = [];
      this.tableData.forEach((item) => {
        if (item.relateList && item.relateList.length > 0) {
          item.relateList.forEach((item2) => {
            tableList.push({
              ...item,
              ...item2,
              classifyId: item.classifyId,
              classifyName: item.classifyName,
            });
          });
        } else {
          tableList.push({
            ...item,
            classifyId: item.classifyId,
            classifyName: item.classifyName,
          });
        }
      });
      return tableList.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (
            key === "index" ||
            key === "itemId" ||
            key === "itemName" ||
            key === "relateItemId" ||
            key === "relateItemName" ||
            key === "rank" ||
            key === "relateList" ||
            key === "classifyId" ||
            key === "classifyName" ||
            key === "relateClassifyName"
          ) {
            newRow[key] = row[key];
            return;
          }
          if (key === "relateRatio") {
            newRow[key] = this.formatPercent(row[key]);
          } else if (key !== "relateRateStr") {
            newRow[key] = this.formatNumber(row[key]);
          } else {
            newRow[key] = row[key];
          }
        });
        return newRow;
      });
    },
    firstColumnLabel() {
      const map = {
        sku: "skuId",
        spu: "商品spu",
        category: "类目Id",
        sellerCategory: "类目Id",
      };
      return map[this.dataType] || "";
    },
    secondColumnLabel() {
      const map = {
        sku: "商品名称",
        spu: "商品名称",
        category: "类目名称",
        sellerCategory: "类目名称",
        itemTag: "标签名称",
      };
      return map[this.dataType] || "";
    },
    thirdColumnLabel() {
      const map = {
        sku: "关联skuId",
        spu: "关联商品Id",
        category: "关联类目Id",
        sellerCategory: "关联类目Id",
        itemTag: "关联标签Id",
      };
      return map[this.dataType] || "关联类目Id";
    },
    fourthColumnLabel() {
      const map = {
        sku: "关联商品名称",
        spu: "关联商品名称",
        category: "关联类目名称",
        sellerCategory: "关联类目名称",
        itemTag: "关联标签名称",
      };
      return map[this.dataType] || "关联类目名称";
    },
		prevReportView(){
			return this.reportParams.reportView || 0;
		}
  },
  methods: {
    // 表格合并方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const firstColField = this.dataType != 'itemTag' ? 'itemId' : 'classifyName';
      // 处理第一行是合计行情况
      if (rowIndex == 0) {
        const firstColProp = firstColField;
        const secondColProp = 'itemName';
        const v1 = row[firstColProp];
        const v2 = row[secondColProp];
        if (v1 === v2 && v1 === '合计') {
          if (column.property === firstColProp) {
            return { rowspan: 1, colspan: 2 };
          }
          if (column.property === secondColProp) {
            return { rowspan: 1, colspan: 0 };
          }
          return { rowspan: 1, colspan: 1 };
        }
      }
      // 按关联率时，不需要合并
      if (this.prevReportView == 1) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      // 需要合并的字段列表
      const mergeFields = this.dataType != 'itemTag'
                          ? ["itemId", "itemName", "buyCount", "buyOrderCount", "buyItemCount", "buyAmount"]
                          : ["index", "itemId", "itemName", "classifyId", "classifyName", "buyCount", "buyOrderCount", "buyItemCount", "buyAmount"];
      // 获取当前列的prop
      const prop = column.property;
      // 如果不是需要合并的字段，不进行合并
      if (!mergeFields.includes(prop)) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      // 检查第一行是否为合计行，若是则第二行跳过向上合并检查（避免被错误地合并到 rowspan=1 的合计行）
      const firstRow = this.countTable[0] || {};
      const isFirstRowTotal = firstRow[firstColField] === firstRow['itemName'] && firstRow[firstColField] === '合计';
      // 查找相同数据的行范围
      if (rowIndex > 0 && !(isFirstRowTotal && rowIndex == 1)) {
        const prevRow = this.countTable[rowIndex - 1];
        const currentRow = this.countTable[rowIndex];
        // 检查当前行和前一行是否需要合并
        let shouldMerge = true;
        for (const field of mergeFields) {
          if (prevRow[field] !== currentRow[field]) {
            shouldMerge = false;
            break;
          }
        }
        if (shouldMerge) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      // 计算当前相同数据的行数
      let rowspan = 1;
      for (let i = rowIndex + 1; i < this.countTable.length; i++) {
        const nextRow = this.countTable[i];
        let isSame = true;

        for (const field of mergeFields) {
          if (this.countTable[rowIndex][field] !== nextRow[field]) {
            isSame = false;
            break;
          }
        }
        if (isSame) {
          rowspan++;
        } else {
          break;
        }
      }
      return {
        rowspan: rowspan,
        colspan: 1,
      };
    },
  },
};
</script>
